<template>
  <v-main>
    <div>
      <v-container class='pa-0 my-5'>
        <v-row class='py-1'>
            <v-card flat class='settings-card'>
              <v-toolbar dense color='primary' tile dark><v-toolbar-title>Voicemail</v-toolbar-title></v-toolbar>
              <v-card-actions class='px-4'>
                <v-container>
                  <v-row>
                    <div>
                      <app-voicemail-settings :click2call="click2call"></app-voicemail-settings>
                    </div>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
        </v-row>
        <v-row class='py-1'>
            <v-card flat class='settings-card'>
              <v-toolbar dense color='primary' tile dark><v-toolbar-title>Call Options</v-toolbar-title></v-toolbar>
              <v-card-actions class='px-4'>
                <v-container>
                  <v-row>Select Input Device</v-row>
                  <v-row><media-input-selector></media-input-selector></v-row>
                  <v-row>Use VOIP</v-row>
                  <v-row><v-switch v-model='useVOIP' class='ma-0 pa-0'></v-switch></v-row>
                  <v-row><app-select-device></app-select-device></v-row>
                  <v-row>
                    <app-pairing-options @openLineKeys="openLineKeys()"></app-pairing-options>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
        </v-row>
        <v-row class='py-1'>
            <v-card flat class='settings-card' >
              <v-toolbar dense color='primary' tile dark><v-toolbar-title>Ringtone</v-toolbar-title></v-toolbar>
              <v-card-actions class='px-4'>
                <v-container>
                  <v-row class='mb-0 pb-0'>Select Ringtone</v-row>
                  <v-row class='mt-0 pt-0'><app-select-ringtone></app-select-ringtone></v-row>
                  <v-row>Play Ringtone</v-row>
                  <v-row>
                    <v-btn icon @click='testRingtone()'>
                      <v-icon>mdi-play-pause</v-icon>
                    </v-btn>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
        </v-row>
        <v-row class='py-1'>
            <v-card flat class='settings-card' >
              <v-toolbar dense color='primary' tile dark><v-toolbar-title>Account</v-toolbar-title></v-toolbar>
              <v-card-actions class='px-4'>
                <v-container>
                  <v-row><v-btn outlined color='red' @click='logout()'>Logout</v-btn></v-row>
                </v-container>
              </v-card-actions>
            </v-card>
        </v-row>
      </v-container>
    </div>
  </v-main>
</template>

<script >
import { mapState } from 'vuex';
import SelectDevice from '../components/select-device.vue';
import PairingOptions from '../components/pairing-options.vue';
import VoicemailSettings from '../components/voicemail-settings.vue';
import LineKeySettings from '../components/line-key-settings.vue';
import MediaInputSelector from '../components/media-input-selector.vue';
import SelectRingtone from '../components/select-ringtone.vue';
import Common from '../mixins/common.vue';
import Voicemail from './voicemail.vue';
export default {
  mixins: [Common],
  data: function() {
    return {
      showLineKeys: false,
    }
  },
  computed: {
    ringtone: {
      get() {return this.$store.state.ringtone}
    },
    device: { get: function() { return this.$store.state.device }},
    useVOIP: {
      get() { return this.$store.state.useVOIP },
      set(v) { this.$store.commit('useVOIP', v) },
    },
  },
  methods: {
    logout: async function() { 
      await this.$store.dispatch('logout');
      this.$router.push('/');
    },
    openLineKeys: function () {
      this.showLineKeys = true;
    },
    closeLineKeys: function () {
      this.showLineKeys = false;
    },
    testRingtone: function() {
      if(this.ringtone.audio.paused) this.ringtone.audio.play();
      else {this.ringtone.audio.pause(); this.ringtone.audio.currentTime = 0.0;}
      console.log(this.ringtone.audio.paused);
    },
  },
  components: {
    'app-select-device': SelectDevice,
    'app-select-ringtone': SelectRingtone,
    'app-pairing-options': PairingOptions,
    'app-voicemail-settings': VoicemailSettings,
    'app-line-key-settings': LineKeySettings,
    'media-input-selector': MediaInputSelector,
    Voicemail,
  },
}
</script>

<style scoped>
.input-group--selection-controls {
  padding: 0;
  margin:0;
}
.settings-card {
  width: 100%;
  margin-left: 12px;
  margin-right: 12px;
  border:2px solid #292961 !important;
}
.v-divider {
  border-color: gray !important;
  margin-top: 0px;
}
</style>
